import { render, staticRenderFns } from "./customerRate.vue?vue&type=template&id=0ace5824&"
import script from "./customerRate.vue?vue&type=script&lang=js&"
export * from "./customerRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports